'use client';

import { Box, Flex, Heading, Text, Image } from "@chakra-ui/react";
import Main from "@/providers/main";
import HomePosts from "@/components/HomePosts";
import HomeColumnists from '@/components/HomeColumnists';
import { preContent, theContent, agoDated } from "@/helpers/utils";
import { LuCircleUserRound, LuTimer } from "react-icons/lu"

export default function DatedAuthor({ post }) {
  return (
     <Flex alignItems="center" textTransform="uppercase" fontSize="0.8em">
        <Flex alignItems="center">
          <LuTimer />

          <Text ml="2">
            { agoDated(post.createdAt) }
          </Text>
        </Flex>

        <Flex alignItems="center" pl="4">
          <LuCircleUserRound />

          <Text ml="2">
            { post.postAuthor }
          </Text>
        </Flex>
      </Flex>
  )
}
